import { Abonent } from '@shared/types/osi/abonents';
import { replace as _replace } from 'lodash';

interface Params {
  (abonentRow: Abonent, OsiId: number | null): Omit<Abonent, 'owner'> & {
    osiId: number | null;
    owner: string | null;
  };
}

export const formatAbonentRow: Params = (abonentRow, osiId) => {
  // external удалён бэкендом (OSI.Core dev 34d6a1f) — поле больше не отправляем в payload.
  const formated = {
    phone: abonentRow.phone ? _replace(_replace(abonentRow.phone, '+7 7', '7'), new RegExp(' ', 'g'), '') : '',
    floor: abonentRow.floor ? abonentRow.floor : 0,
    livingJur: abonentRow.livingJur ? abonentRow.livingJur : 0,
    livingFact: abonentRow.livingFact ? abonentRow.livingFact : 0,
    square: abonentRow.square ? abonentRow.square : 0,
    effectiveSquare: abonentRow.effectiveSquare ? abonentRow.effectiveSquare : 0,
    flat: abonentRow.flat,
    name: abonentRow.name,
    idn: abonentRow.idn,
    // OSI-788: в payload уходит СЫРОЕ русское значение («Собственник»/«Арендатор») как есть.
    // 1) Бэк валидирует поле атрибутом [Values("Собственник","Арендатор")] (AbonentRequest.cs),
    //    поэтому отправлять сюда локализованный (казахский) текст нельзя — будет 400.
    // 2) Пустое значение отправляем как null, а НЕ как ''. Причина: AutoMapper-профиль
    //    (OSI.Core/Models/AppMappingProfile.cs) для Owner не использует UseDestinationValue,
    //    т.е. значение из запроса всегда перезаписывает значение в БД. Отправка ''
    //    превратила бы NULL в пустую строку и на каждом сохранении писала бы лишнюю
    //    запись в abonents_history (AbonentSvc сравнивает abonentHistory.Owner != abonent.Owner).
    //    null оставляет уже пустое поле пустым, а непустое значение сохраняется round-trip'ом
    //    (строка приходит с GET и уходит обратно без изменений) — «Владелец» больше не затирается.
    //    Раньше здесь было `abonentRow.owner?.nameRu` — у строки такого поля нет, в payload
    //    уходил undefined и бэк обнулял Owner при любом сохранении строки.
    owner: abonentRow.owner ?? null,
    areaTypeCode: abonentRow.areaTypeCode,
    parentAbonentId: abonentRow.parentAbonentId ?? null,  // Фаза 2: привязка к родительскому помещению
    id: abonentRow.id,
    osiId
  };

  return formated;
};
